export enum SearchBarTheme {
    White = 'white',
    Gray = 'gray'
}